import { render, staticRenderFns } from "./author_intro.vue?vue&type=template&id=6e95c3ee"
import script from "./author_intro.vue?vue&type=script&lang=js"
export * from "./author_intro.vue?vue&type=script&lang=js"
import style0 from "./author_intro.vue?vue&type=style&index=0&id=6e95c3ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports